import { FoldOut, ProductInfo, ProductInfoSummary, ProductTable } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import car_sample from '../../resources/mocks/car_sample.jpg';
import { useSearchVehicleQuery } from '../../services/redux/features/api/search-vehicle.slice';
import { journeyDataSelectors } from '../../services/redux/features/journeyData.slice';
import { ProductFamilyEnum } from '../../types/productFamilySelection';
import { applicationSummaryMapper } from './applicationSummary.mapper';
import { ApplicationSummaryData } from './applicationSummary.model';
import { RenderNonServicePlanAppplicationSummary } from './ApplicationSummaryNonServicePlanTable';
import { RenderServicePlanAppplicationSummary } from './ApplicationSummaryServicePlanTable';

interface ApplicationSummaryProps {
  isDefaultOpen?: boolean;
}

export const ApplicationSummary: FunctionComponent<ApplicationSummaryProps> = ({ isDefaultOpen = true }) => {
  const { t } = useTranslation();

  const { isLoading, data } = useSearchVehicleQuery();
  const [mappedData, setMappedData] = useState<ApplicationSummaryData>();
  const [caption, setCaption] = useState('');
  const [title, setTitle] = useState('');
  const productFamily = useSelector(journeyDataSelectors.productFamily);

  const [defaultOpen, _setDefaultOpen] = useState(isDefaultOpen);
  const productTableContent =
    productFamily === ProductFamilyEnum.servicePlan ? (
      <RenderServicePlanAppplicationSummary />
    ) : (
      <RenderNonServicePlanAppplicationSummary />
    );

  useEffect(() => {
    if (data) {
      const summaryData = applicationSummaryMapper(data);
      setCaption(summaryData.vehicleShortDescription || '');
      // TODO PC-3689 Title consists of model name only, currently not available in the data
      setTitle('Q8');
      setMappedData(summaryData);
    }
  }, [data]);

  return (
    !isLoading &&
    mappedData && (
      <FoldOut
        defaultOpen={defaultOpen}
        productInfoSummary={
          <ProductInfoSummary
            imgSrc={car_sample}
            infoLabel={t('applicationSummary:total')}
            infoValue={mappedData.total}
            subtitle={caption}
            title={title}
          />
        }
      >
        <ProductInfo
          media={<img alt={mappedData.vehicleModel} src={car_sample} />}
          titleTagline={t('applicationSummary:applicationSummary')}
          className="u-mb"
        >
          <ProductTable title={mappedData.vehicleModel} />
        </ProductInfo>
        {productTableContent}
      </FoldOut>
    )
  );
};
